<template>
  <div class="root-app">
    <div
      id="my-wallet-container"
      class="grid-x my-wallet-home-container align-center"
      :class="{ 'promotion-offers': route.path == '/shop/coupons-deals', 'account-wallet': route.path == '/account/wallet' }"
    >
      <div id="my-wallet-hom" class="grid-x my-wallet-home padding-bottom-s" :class="isNotRewardPage ? 'wallet-home-width' : 'print-reward-width'">
        <div v-if="showLeftNavAndBreadcrumb()" class="cell large-3 show-for-large lfn-container">
          <LeftNavBCOM />
        </div>
        <div v-if="headerLoader" :class="['cell', showLeftNavAndBreadcrumb() ? 'large-8 my-bwallet' : 'large-12']">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

import { loadTagLibrary, fireTag } from '@vue-util/tagManager';
import sessionTimeOutHandler from '../utils/interceptors/SessionTimeOutHandler';
import LeftNavBCOM from '../components/LeftNavBCOM.vue';
import { useEnvPropsStore } from '../stores/envProps';
import { useLocalStore } from '../stores/Local';
import { useRouter, useRoute } from 'vue-router';
import requestInterceptor from '../utils/interceptors/PersistentLoginRequestInterceptor';
import { ExperimentationTags } from '@vue-util/experimentation';

const envPropsStore = useEnvPropsStore();
const localStore = useLocalStore();
const { envProps } = storeToRefs(envPropsStore);

const router = useRouter();
const route = useRoute();
const footerLoader = ref(true);
const headerLoader = ref(false);
const appMounted = ref(false);
const isNotRewardPage = ref(true);

const showLeftNavAndBreadcrumb = () => {
  const hiddenRoutes = ['printPromotionalGiftCard', 'promotionoffers', 'printReward'];
  return !hiddenRoutes.includes(route.name);
};

// Lifecycle hook
onMounted(async () => {
  if (route.path === '/account/wallet') {
    const query = { ...route.query, ocwallet: true };
    router.push({ path: '/account/wallet', query });
  }

  const entryPoint = envProps.value?.entryPoint;
  const tagManger = envProps.value?.tagMngrEnv;
  loadTagLibrary(entryPoint, tagManger, true);

  isNotRewardPage.value = route.path !== '/account/printreward';
  window.medalliaSurveyData = 'in My Wallet';
  setTimeout(() => {
    footerLoader.value = false;
    headerLoader.value = true;
  }, 1000);

  if (route.path === '/shop/coupons-sales-promotions') {
    fireTag('view', { page_name: 'sales and promotions', page_type: 'marketing' });
    const pageData = envProps.value?.pageData;
    if (pageData) {
      localStore.setPageData(pageData);
    }
  }

  ExperimentationTags.fireAdobeTags();

  if (envProps?.value?.killswitches?.persistentLoginEnabled && envProps?.value?.killswitches?.persistentLoginForWalletPageEnabled) {
    requestInterceptor();
  }
  sessionTimeOutHandler();
  appMounted.value = true;
});
</script>

<style lang="scss" scoped>
@import '~@core/csg/src/scss/settings/bcom.scss';
@import '~appSCSS';
.root-app {
  .account-wallet {
    @include breakpoint(large up) {
      margin-left: 28px;
    }
  }
  @include breakpoint(small only) {
    #my-wallet-container {
      padding: rem-calc(0 20 0 20);
    }
    .account-wallet {
      margin-left: 0px;
    }
  }
  .my-wallet-home-container {
    .my-wallet-home {
      margin: rem-calc(0 16 0 16);
      max-width: rem-calc(1601);
      width: 100%;
      padding: rem-calc(32 32 0 32);
      @include breakpoint(small only) {
        padding: rem-calc(0);
      }
      .my-bwallet {
        @media only screen and (min-width: rem-calc(1024)) {
          width: 750px;
        }

        @media only screen and (min-width: rem-calc(1440)) {
          width: 930px;
        }
      }
    }
  }
}
.grid-x > .small-12 {
  width: 100%;
  padding-bottom: rem-calc(10);
}
.skeleton-cell {
  width: 33%;
  float: left;
  padding: rem-calc(2);
}
.promotion-offers {
  background: #eeeeee;
}
@media only screen and (max-width: rem-calc(600)) {
  .my-wallet-home {
    margin: rem-calc(0) !important;
    padding: rem-calc(0) !important;
  }

  .promotion-offers {
    width: rem-calc(500) !important;
    .my-wallet-home {
      width: 95% !important;
      padding: rem-calc(0) !important;
    }
  }
}
@media only screen and (max-width: rem-calc(400)) {
  .promotion-offers {
    width: rem-calc(390) !important;
    .my-wallet-home {
      width: 95% !important;
      padding: rem-calc(0) !important;
    }
  }
}
</style>

<style lang="scss" brand="bcom">
.root-app {
  @include breakpoint(small only) {
    padding: rem-calc(15) !important;
    #my-wallet-container .breadcrumb-main {
      margin: rem-calc(0 0 20 0);
    }
  }

  .my-wallet-home-container .my-wallet-home {
    margin: rem-calc(0 14 0 14);
    max-width: 90rem !important;
    padding: rem-calc(24 0 0 0) !important;
  }
}
.lfn-container {
  width: 22% !important;
}
.grey-text {
  color: #6e6e6e;
}

.left-nav {
  margin-left: rem-calc(2px) !important;
  .submenu {
    p {
      margin-bottom: 0;
    }
    a:hover {
      color: #d90eac;
    }
  }
  .left-nav-header-wrapper {
    display: none;
  }
  h2 {
    font-size: rem-calc(16) !important;
    line-height: rem-calc(20px);
  }
}
.wallet-home-width {
  margin: rem-calc(0 16 0 16) !important;
}

.print-reward-width {
  margin: 0 !important;
}
</style>
